import Modal from "components/modal";
import CloseIcon from "assets/icons/close.svg";
import { Button } from "components/button";
import RadioGroup from "components/radio-group";
import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useGenerateShipping } from "api/use-shipping";
import { getQueryParams } from "lib/utils";

export default function ShippingModal({
  setModalOpen,
  modalOpen,
  customerId,
  takebackId,
  shipping,
  weight,
}) {
  const [selectedOption, setSelectedOption] = useState(null);
  // const [displayState, setDisplayState] = useState("choose");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const location = useLocation();
  const queryParams = getQueryParams(location.search);

  const navigate = useNavigate();
  // const [shippingData, setShippingData] = useState(null);
  // const [shippingPending, setShippingPending] = useState(false);

  // useEffect(() => {
  //   if (labelTracking !== undefined && labelTracking?.data?.length > 0) {
  //     setShippingData(labelTracking.data[0]);
  //     setShippingPending(false);
  //   }
  // }, [labelTracking]);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     if (!shippingData) {
  //       setShippingPending(true);
  //     }
  //   }, 3000);

  //   return () => clearTimeout(timer);
  // }, [shippingData]);

  // const qrUrl = shippingData?.shipping_metadatas?.items?.find(
  //   (item) => item.key === "label_url"
  // )?.value;

  const generateShipping = useGenerateShipping({
    onSuccess: () => {
      navigate(0);
    },
    onError: () => {
      setIsSubmitting(false);
      window.alert("Failed to create shipping");
    },
  });

  const radioOptions = [
    {
      value: "MAIL_NOLABEL",
      title: "Using a free shipping QR code",
      // pending: !shippingData || !qrUrl,
      // disabled: !shippingData || !qrUrl,
      subtitle: (
        <>
          Drop-off at{" "}
          <a
            className="text-blue cursor-pointer"
            href="https://www.theupsstore.com/tools/find-a-store"
            target="_blank"
            rel="noopener noreferrer"
          >
            The{"\u00A0"}UPS{"\u00A0"}Store®
            <span className="material-symbols-outlined align-bottom text-base scale-[0.7] h-5 w-5 -translate-y-[1px]">
              open_in_new
            </span>
          </a>
        </>
      ),
    },
    {
      value: "MAIL_LABEL",
      title: "Using a free shipping label",
      // pending: !shippingData,
      // disabled: !shippingData,
      subtitle: (
        <>
          Print, attach and take to any{" "}
          <a
            className="text-blue cursor-pointer"
            href="https://www.ups.com/dropoff/?loc=en_US"
            target="_blank"
            rel="noopener noreferrer"
          >
            UPS Location
            <span className="material-symbols-outlined align-bottom text-base scale-[0.7] h-5 w-5 -translate-y-[1px]">
              open_in_new
            </span>
          </a>
        </>
      ),
    },
  ];

  const onConfirm = () => {
    setIsSubmitting(true);
    generateShipping.mutate({
      takeback_id: takebackId,
      customer_id: customerId,
      type: selectedOption,
    });
  };

  const ChooseScreen = () => {
    return (
      <>
        <div className="flex flex-col space-y-x-large py-4">
          <div className="flex justify-between ">
            <div className="flex flex-col space-y-2 -mt-1">
              <h2 className="text-4xl font-semibold leading-none">
                Choose shipping method
              </h2>
              <Link
                className="text-blue cursor-pointer w-fit text-sm"
                to={`/en-US/preparation-guidelines?state=${queryParams?.state}#packagingGuidelines`}
                target="_blank"
                rel="noopener noreferrer"
              >
                View packaging guidelines{" "}
                <span className="material-symbols-outlined align-bottom text-base scale-[0.7] h-5 w-5 -translate-y-[1px]">
                  open_in_new
                </span>
              </Link>
            </div>
            <div className="cursor-pointer" onClick={() => setModalOpen(false)}>
              <img src={CloseIcon} alt="" variant="secondary" />
            </div>
          </div>
          <RadioGroup
            options={radioOptions}
            name="shipping-method"
            selectedOption={selectedOption}
            onChange={setSelectedOption}
            className="mt-2"
          />
        </div>
        <div className="flex justify-between mt-2">
          <Button
            className=""
            variant="secondary"
            onClick={() => setModalOpen(false)}
          >
            Cancel
          </Button>
          <Button
            className=""
            onClick={onConfirm}
            disabled={!selectedOption || isSubmitting}
          >
            {isSubmitting ? "Creating..." : "Confirm"}
          </Button>
        </div>
      </>
    );
  };

  // const QRScreen = () => {
  //   return (
  //     <>
  //       <div className="flex flex-col justify-between">
  //         <div className="flex justify-end">
  //           <div className="cursor-pointer" onClick={() => setModalOpen(false)}>
  //             <img src={CloseIcon} alt="" variant="secondary" />
  //           </div>
  //         </div>
  //         <div className="flex flex-col space-y-3 w-full items-center">
  //           <img
  //             src="/static/media/logo.4f05a22b8fee49f8826e.jpg"
  //             alt="LEGO"
  //             className="w-12 h-12"
  //           />

  //           <h2 className="text-4xl font-semibold max-w-[260px] text-center leading-snug -mb-2">
  //             Your trade-in shipping QR code
  //           </h2>

  //           <img
  //             src={qrUrl}
  //             alt="QR Code"
  //             className="max-w-64"
  //             style={{
  //               objectFit: "cover",
  //               objectPosition: "center",
  //               clipPath: "inset(20% 10% 20% 10%)",
  //             }}
  //           />
  //         </div>
  //       </div>
  //       <div className="flex justify-between mt-2">
  //         <Button
  //           className=""
  //           variant="secondary"
  //           onClick={() => setDisplayState("choose")}
  //         >
  //           Back
  //         </Button>
  //         <Button className="" onClick={() => setModalOpen(false)}>
  //           Done
  //         </Button>
  //       </div>
  //     </>
  //   );
  // };

  return (
    <Modal
      setModalOpen={setModalOpen}
      modalOpen={modalOpen}
      className="flex flex-col justify-between max-h-[90vh]"
      style={{
        transition: "min-height 0.5s ease-out",
        // minHeight: displayState === "choose" ? "100px" : "600px",
      }}
      isLoading={isSubmitting}
      loadingMessage={`Creating ${selectedOption === "MAIL_NOLABEL" ? "QR Code" : "Shipping Label"}`}
      // loadingSubtitle={`Bare with us for a moment while we get your ${selectedOption === "MAIL_NOLABEL" ? "QR code" : "shipping label"} ready.`}
      disableBackdropClick={isSubmitting}
    >
      <ChooseScreen />
    </Modal>
  );
}
